import React from "react";
import { Bell, LogOut, Users } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function AppHeader() {
  const { member, logout } = useAuth();
  return (
    <header className="sticky top-0 z-30 bg-primary text-white px-4 py-3 flex items-center justify-between shadow-md">
      <div className="flex items-center gap-2.5">
        <div className="h-10 w-10 rounded-xl bg-white/15 flex items-center justify-center">
          <Users className="h-5 w-5" />
        </div>
        <div className="leading-tight">
          <p className="font-display font-bold text-lg">अपना समूह</p>
          <p className="text-[11px] text-white/75 -mt-0.5">
            {member.role === "admin" ? "Admin" : "Member"} · {member.name}
          </p>
        </div>
      </div>
      <div className="flex items-center gap-1.5">
        <button className="h-9 w-9 rounded-full bg-white/10 flex items-center justify-center" data-testid="notif-btn">
          <Bell className="h-4 w-4" />
        </button>
        <button
          data-testid="logout-btn"
          onClick={logout}
          className="h-9 w-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors"
        >
          <LogOut className="h-4 w-4" />
        </button>
      </div>
    </header>
  );
}
